import { trackEvent } from "@hopper-b2b/api";
import { CONTINUE_TO_PAYMENT_PRICE_FREEZE } from "@hopper-b2b/types";
import type { PriceFreezeMachineContext } from "../types";

export const trackUberPaymentPf = (
  context: PriceFreezeMachineContext,
  _event: unknown
) =>
  new Promise((resolve, _reject) => {
    trackEvent({
      eventName: CONTINUE_TO_PAYMENT_PRICE_FREEZE,
      properties: undefined,
    })
      .then(() => resolve(null))
      .catch(() => resolve(null));
  });
